import { tv } from "tailwind-variants";

interface Props {
  children: JSX.Element
  title: string
  style?: "grid" | "row" | "fullRow"
  border?: boolean
}

function FormContainer({ children, title, style = "grid", border = true }: Props) {
  const { container } = tv({
    slots: {
      container: `w-full flex py-10 gap-6 ${border == true ? "border-b-[1px] border-border-light-mode dark:border-border-dark-mode" : ""}`
    },
    variants: {
      style: {
        grid: {
          container: "items-center lg:items-start lg:flex-row flex-col"
        },
        row: {
          container: "items-center lg:items-start lg:flex-row flex-col"
        },
        fullRow: {
          container: "items-center lg:items-start lg:flex-row flex-col"
        },
      }
    }
  })()


  return (
    <div className={container({ style })}>
      <div className="w-full flex justify-center lg:justify-start lg:w-[20%]">
        <h1 className="text-black dark:text-white">{title}</h1>
      </div>
      {
        style == "grid" &&
        <div className="w-[80%] grid gap-6 grid-cols-1 lg:grid-cols-2 2xl:grid-cols-3 grid-flow-row-dense ">
          {
            children
          }
        </div>
      }
      {
        style == "fullRow" &&
        <div className="w-[80%] flex flex-col gap-6 ">
          {
            children
          }
        </div>
      }
      {
        style == "row" &&
        <div className="w-[80%] flex flex-col gap-6 max-w-[550px] ">
          {
            children
          }
        </div>
      }
    </div>
  );
}

export default FormContainer;